<ng-container *transloco="let t">
    <div class="d-flex">
        <ng-container *ngFor="let count of displayCount; trackBy: trackByCountKey">
            <ng-container *ngIf="competitorCount && (!hideZeroCounts || (competitorCount[count] && competitorCount[count]! > 0))">
                <div class="me-3 competitor-count-badge pulse-brightness"
                     [ngClass]="[classMap.get(count) ?? '', size === 'small' ? 'competitor-count-badge-small' : '']">
                    <span class="text-uppercase">
                        {{
                            labelsMap.get(count)
                            ? (t(labelsMap.get(count)!) | uppercase)
                             : ''
                        }} : {{ competitorCount[count] ?? '-' }}
                    </span>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
